import Alpine from 'alpinejs'

window.Alpine = Alpine;


//ECHO for pusher
import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '172533fa493345ed98f5',
    cluster: 'ap2',
    forceTLS: true
});

console.log('echo', window.Echo);
